import { RiRouterLine } from "@onemind-services-llc/react-icons-ng/ri";
import { AiOutlineBug } from "@onemind-services-llc/react-icons-ng/ai";
import { MdCloudUpload } from "@onemind-services-llc/react-icons-ng/md";
import { ListWithLabel } from "@/components/list";

export const USE_CASES_CONSTANTS = {
  title: "Use Cases for Emulation, Simulation, and Real-World Testing",
  list: [
    {
      icon: RiRouterLine,
      title: "Network Testing",
      content: (
        <ListWithLabel
          points={[
            {
              label: "Emulation",
              text: "Creates virtual replicas of routers and switches for testing configurations.",
            },
            {
              label: "Simulation",
              text: "Models large-scale network environments for predicting traffic behavior.",
            },
            {
              label: "Real-World Testing",
              text: "Deploys new network architectures and validates performance in live conditions.",
            },
          ]}
        />
      ),
    },
    {
      icon: AiOutlineBug,
      title: "Cybersecurity Assessments",
      content: (
        <ListWithLabel
          points={[
            {
              label: "Emulation",
              text: "Tests security tools against real-world attack scenarios in a virtualized lab.",
            },
            {
              label: "Simulation",
              text: "Analyzes potential vulnerabilities through AI-driven attack modeling.",
            },
            {
              label: "Real-World Testing",
              text: "Deploys security solutions in production environments to monitor real-time threats.",
            },
          ]}
        />
      ),
    },
    {
      icon: MdCloudUpload,
      title: "Cloud Migration & Virtualization",
      content: (
        <ListWithLabel
          points={[
            {
              label: "Emulation",
              text: "Tests applications in a cloud-like virtual environment before full migration.",
            },
            {
              label: "Simulation",
              text: "Models workload distribution and resource allocation for cost and efficiency predictions.",
            },
            {
              label: "Real-World Testing",
              text: "Moves production applications to the cloud and monitors performance.",
            },
          ]}
        />
      ),
    },
  ],
};
